import useRaWidgetsConfig from './useRaWidgetsConfig';

const MAX_LIMIT = 50;

const useRaWidgetConfigPayload = widgetName => {
  const widgetsConfig = useRaWidgetsConfig();
  const widgetConfig = widgetsConfig.value[widgetName];

  const limit = widgetConfig.show_all_segments ? MAX_LIMIT : widgetConfig.limit;

  return { limit };
};

export default useRaWidgetConfigPayload;
